var exports = {
  "JW": "SignalStrengthIcon.module__svg___em12U3",
  "wL": "SignalStrengthIcon.module__green___em12U3",
  "D9": "SignalStrengthIcon.module__yellow___em12U3",
  "T_": "SignalStrengthIcon.module__orange___em12U3",
  "wv": "SignalStrengthIcon.module__red___em12U3",
  "Xe": "SignalStrengthIcon.module__tertiary___em12U3",
  "cQ": "SignalStrengthIcon.module__tertiaryMuted___em12U3",
};

module.exports = exports;
